module.exports = __webpack_public_path__ + "static/media/bars-emoji-strongly-agree.3022f313.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/bars-emoji-strongly-agree.svg
// module id = 683
// module chunks = 0